import { Component, computed, input } from '@angular/core';
import { type MarketClockState, type TradingPeriod } from '../../app-clock.model';
import { marketTimeLabelsFor, timeSliceSegments } from '../../utils/clock.utils';

@Component({
	selector: 'app-market-time-slicer',
	templateUrl: './market-time-slicer.component.html',
	styleUrl: './market-time-slicer.component.scss',
	host: { class: 'block w-full' }
})
export class MarketTimeSlicerComponent {
	readonly periods = input.required<readonly TradingPeriod[]>();
	readonly state = input.required<MarketClockState>();

	readonly segments = computed(() => timeSliceSegments(this.periods()));
	private readonly timeLabels = computed(() => marketTimeLabelsFor(this.periods(), this.segments()));
	readonly upperTimeLabels = computed(() => this.timeLabels().upper);
	readonly lowerTimeLabels = computed(() => this.timeLabels().lower);

	readonly timelineDescription = computed(() => {
		const descriptions = this.periods().map(period =>
			period.type === 'preTrading'
				? `پیش‌گشایش از ${period.start} تا ${period.end}`
				: `معاملات پیوسته از ${period.start} تا ${period.end}`
		);
		return descriptions.length > 0 ? descriptions.join('، ') : 'امروز زمان معامله‌ای ثبت نشده است';
	});
}
